import { Component, OnInit, EventEmitter, Output, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { getProfAmount } from "../../../../globals";
import * as moment from 'moment';
const fee = 1.49;


@Component({
  selector: 'service-newData',
  templateUrl: '../../templates/partials/newData-service.html'
})
export class NewDataServiceComponent implements OnInit{

    @Input() settings;
    public serviceData: FormGroup;
    public applyDiscount: boolean = false;
    public createService: object = {};
    public products: boolean;
    public payment;
    public dateDisabled: {date: Date, mode: string}[];
    public import = {
        Price: "10",
        PriceHour: "0",
        Subtotal: "0",
        Discount: 0,
        Total: "0",
    };

    public dt = void 0;
    public formatDate;
    private opened: boolean = false;
    @Output() DataChangeEmitter = new EventEmitter();
    @ViewChild("dateFrom") datepicker;

    constructor(private _fb: FormBuilder){}

    public showDiscountForm(){

        this.applyDiscount = true;
    }

    public changeImport(){
       
       if(this.serviceData.value.duration && this.import.Price){
            let duration = parseFloat(this.serviceData.value.duration);
            //let discount = parseFloat(this.import.Discount);    
            //this.import.Subtotal = subtotal.toFixed(2);
            let price = parseFloat(this.import.Price);
            var totalHourPrice = (duration * price);
            var totalPrice = (duration * price) + parseFloat(this.serviceData.value.fee);
            if(this.products) totalPrice += parseFloat(this.settings.products);
            if(this.settings["transport"]["price"] != 0) totalPrice += parseFloat(this.settings["transport"]["price"]);
            this.import.PriceHour = totalHourPrice.toFixed(2);
            this.import.Total = totalPrice.toFixed(2);
        }
    }

    public closeDatePicker($event) {
        if($event.relatedTarget == null || $event.relatedTarget.type == "text" ){
            this.opened = false;
        }
    }

    public closeSibiling(event){
        this.parseCreateService();
    }

    public parseCreateService(){
        var time_string = this.serviceData.controls.hour.value;
        if(time_string != null){
            var time = moment(time_string,"HH:mm");
            var time_ini = time.format("HH:mm");
            var date = moment();
            var time_end = date.set({hour: time.get("hour"), minute: time.get("minute")});
            var n_hours = parseFloat(this.serviceData.controls.duration.value);
            time_end.add(n_hours,"hours");
        }
        let price = parseFloat(this.import.Price);

        var payment_method,products;
        payment_method = this.payment;
        products = this.products;
       
        let comission = this.settings["comissions"][price.toFixed(2)];
        if(comission != null){
            let comissionPer = comission["comission"];
            let proHour = comission["cleaner"];
            let comissionAmount = comission["benefit"] * n_hours;
            let professionalAmount = proHour * n_hours;
            let transport = this.settings["transport"]["price"];
            let productsPrice = (products) ? parseFloat(this.settings["products"]) : 0;
            let app_queue = (this.serviceData.controls.clintuComments.value == '' || this.serviceData.controls.clintuComments.value == null) ? 1 : 0;
            
            let total_amount_real = parseFloat(this.import.PriceHour) + productsPrice + parseFloat(transport);
            this.createService = {
                    date: moment(this.datepicker["formatDate"],"DD/MM/YYYY").format("YYYY-MM-DD"),
                    time_ini: time_ini,
                    time_end: time_end.format("HH:mm"),
                    duration: n_hours,
                    periodicity: this.serviceData.controls.periodicity.value,
                    price: parseFloat(this.import.Price),
                    askProfessional: 0,
                    withProducts: products,
                    howMetUs: this.serviceData.controls.howMetUs.value,
                    inHome: 0,
                    proComments: this.serviceData.controls.proComments.value,
                    clintuComments: this.serviceData.controls.clintuComments.value,
                    productPrice: productsPrice,
                    productsAmount: productsPrice,
                    fee: parseFloat(this.serviceData.controls.fee.value),
                    paymentMethod: payment_method,
                    n_professional: 1,
                    app_queue: app_queue,
                    transport: transport,
                    transportAmount: transport,
                    discount_data: {},
                    discount: {},
                    discountCode: "",
                    discount_amount:0,
                    discount_hour_amount:0,
                    discount_percent_amount: 0,
                    hours_amount: this.import.PriceHour,
                    total_amount: total_amount_real.toFixed(2),
                    total_amount_real: total_amount_real.toFixed(2),
                    comissionPercent: comissionPer,
                    comissionAmount: comissionAmount,
                    professionalAmount: professionalAmount,
                    professionalHourPrice: proHour
                }
            //console.log(this.createService)
            }
            this.checkFormValid();
    }

    public changePrice(increment: string){
        var price = parseFloat(this.import.Price);
        if(price > 7){
           
            if(increment == "minus"){
                price -= 0.05;
            }else{
                price += 0.05;
            } 
            this.import.Price = price.toFixed(2);
        }
        this.changeImport();
        this.parseCreateService();
    }

    public setProducts(number: boolean){
        this.products = number;
        this.changeImport();
        this.parseCreateService();
    }

    public setPayment(value: string){
        this.payment = value;
        this.changeImport();
        this.parseCreateService();
    }

    public checkFormValid(){
        let price = parseFloat(this.import.Price);
        if(this.serviceData.status == "VALID" && this.datepicker["dt"] != null && this.products != null && this.payment != null && this.settings["comissions"][price.toFixed(2)] != null){
            this.DataChangeEmitter.emit({valid: true, data: this.createService});
        }else{
            this.DataChangeEmitter.emit({valid: false, data: this.createService});
        }
    }

    ngOnInit(){
        this.serviceData = this._fb.group({
            hour: ['', [Validators.required]],
            duration: ['', [Validators.required]],
            periodicity: ['', [Validators.required]],
            fee: [fee, [Validators.required]],
            howMetUs: ['', [Validators.required]],
            proComments: [''],
            clintuComments: ['']
        });
        this.serviceData.valueChanges.subscribe(value => {
            this.changeImport();
            this.parseCreateService();  
        });

    }
    
}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/newData-service.component.ts